const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1']);
const MOBILE_PRODUCTION_BACKEND_URL = 'https://zaptresumo-backend.onrender.com';

function normalizeBaseUrl(url) {
  return url ? url.replace(/\/+$/, '') : '';
}

function isNativeRuntime() {
  if (typeof window === 'undefined') {
    return false;
  }

  const protocol = window.location?.protocol || '';
  return Boolean(window.Capacitor) || protocol === 'capacitor:' || protocol === 'ionic:';
}

export function getBackendBaseUrl() {
  const configuredBaseUrl = normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL || '');

  if (typeof window === 'undefined') {
    return configuredBaseUrl || 'http://localhost:8000';
  }

  if (isNativeRuntime()) {
    if (!configuredBaseUrl) {
      return MOBILE_PRODUCTION_BACKEND_URL;
    }

    try {
      const configuredUrl = new URL(configuredBaseUrl);
      if (LOOPBACK_HOSTS.has(configuredUrl.hostname)) {
        return MOBILE_PRODUCTION_BACKEND_URL;
      }
    } catch {
      return MOBILE_PRODUCTION_BACKEND_URL;
    }

    return configuredBaseUrl;
  }

  const isDevServer =
    window.location.port === '3000' &&
    (window.location.protocol === 'http:' || window.location.protocol === 'https:');

  if (isDevServer) {
    return window.location.origin;
  }

  const currentProtocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  const currentHostname = window.location.hostname || 'localhost';
  const localNetworkBaseUrl = `${currentProtocol}//${currentHostname}:8000`;

  if (!configuredBaseUrl) {
    return localNetworkBaseUrl;
  }

  try {
    const configuredUrl = new URL(configuredBaseUrl);
    const configuredHostIsLoopback = LOOPBACK_HOSTS.has(configuredUrl.hostname);
    const currentHostIsLoopback = LOOPBACK_HOSTS.has(currentHostname);

    if (!currentHostIsLoopback && configuredHostIsLoopback) {
      return localNetworkBaseUrl;
    }

    return configuredBaseUrl;
  } catch {
    return configuredBaseUrl;
  }
}

export const API = `${getBackendBaseUrl()}/api`;
